"use client";
import VideoPlayer from "@/components/common/VideoPlayer";
import Thumbnail from "../Thumbnail";
import { type VideoModuleType } from "../types";

export interface PlayerProps {
  module: VideoModuleType;
}

export default function Player(props: PlayerProps) {
  const {
    module: {
      body: {
        videoSource,
        videoId,
        customThumbnail,
        aspectRatio,
        mediaDisplayVariant,
      },
    },
  } = props;

  return (
    <VideoPlayer
      source={videoSource}
      videoId={videoId}
      renderThumb={() => (
        <Thumbnail
          source={videoSource}
          videoId={videoId}
          thumbnail={customThumbnail}
        />
      )}
      aspectRatio={aspectRatio}
      openIn={mediaDisplayVariant}
    />
  );
}
